import { render, staticRenderFns } from "./PokeDetails.vue?vue&type=template&id=3a5bb850&"
import script from "./PokeDetails.vue?vue&type=script&lang=ts&"
export * from "./PokeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports